/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Box } from 'rebass'

const Hero = (props) => {
    return (
        <Box {...props}
            bg={props.bg}
            color={props.color}
            sx={{
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            {props.children}
        </Box>
    )
}

Hero.defaultProps = {
    bg: 'black',
    color: 'white',
}

Hero.displayName = 'Hero'

export default Hero
